import {
  MissingTranslationHandler,
  TranslateLoader,
  TranslateModule,
  TranslateService,
} from '@ngx-translate/core';
import { NgModule } from '@angular/core';
import { ThemeDetailsStepperComponent } from './theme-details/components/theme-details-stepper.component';
import { ThemeDetailsLinkComponent } from './theme-details/components/theme-details-link.component';
import { ThemeDetailsFormComponent } from './theme-details/theme-details-form.component';
import { ThemeListComponent } from './theme-list/theme-list.component';
import {
  MAT_COLOR_FORMATS,
  NgxMatColorPickerModule,
  NGX_MAT_COLOR_FORMATS,
} from '@angular-material-components/color-picker';
import { SharedModule } from 'src/app/shared/modules/shared.module';
import { ConfirmationDialogModule } from '../confirmation-dialog/confirmation-dialog.module';
import { StringResourceService } from 'src/app/services/string-resource.service';
import ThemingTranslationLoader from './theming-translation-loader';
import CommonMissingTranslationHandler from 'src/app/utilities/common-missing-translation-handler';
import { ThemeApprovalComponent } from './theme-details/theme-approval/theme-approval.component';
import { DatePipe } from '@angular/common';

@NgModule({
  imports: [
    ConfirmationDialogModule,
    SharedModule,
    TranslateModule.forChild({
      isolate: true,
      loader: {
        provide: TranslateLoader,
        useClass: ThemingTranslationLoader,
        deps: [StringResourceService],
      },
      missingTranslationHandler: {
        provide: MissingTranslationHandler,
        useClass: CommonMissingTranslationHandler,
      },
    }),
    NgxMatColorPickerModule,
  ],
  declarations: [
    ThemeDetailsFormComponent,
    ThemeDetailsLinkComponent,
    ThemeDetailsStepperComponent,
    ThemeListComponent,
    ThemeApprovalComponent,
  ],
  providers: [
    { provide: MAT_COLOR_FORMATS, useValue: NGX_MAT_COLOR_FORMATS },
    DatePipe,
  ],
  exports: [ThemeDetailsLinkComponent, ThemeListComponent],
})
export class ThemingModule {
  constructor(protected translate: TranslateService) {}
}
